export default __webpack_public_path__ + "static/InteracLogo-088cfb980f2b038307d418a8a4100189.png";